import { FiUsers } from "react-icons/fi";
import StatisticsCard from "./StatisticsCard";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { MdOutlinePayment } from "react-icons/md";
import { formatRecordedMoney } from "utils/recordedMoney";

export default function Statistics({ registeredUsers, usdCommission, zigCommission, usdPayout, zigPayout, netUsdCommission, netZigCommission, totalPaymentsMade, showPayments = true, currencies, commissionsByCurrency, payoutsByCurrency, netCommissionsByCurrency }) {
    const metadata = currencies || [{ code: "USD", label: "USD" }, { code: "ZWL", label: "ZiG" }];
    const gross = commissionsByCurrency || { USD: usdCommission, ZWL: zigCommission };
    const payouts = payoutsByCurrency || { USD: usdPayout, ZWL: zigPayout };
    const net = netCommissionsByCurrency || { USD: netUsdCommission, ZWL: netZigCommission };
    return <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <StatisticsCard label="Registered users" statistic={registeredUsers} icon={FiUsers} bgWhite />
            <StatisticsCard label="Total payments made" statistic={totalPaymentsMade} icon={MdOutlinePayment} view={showPayments ? "/ba/client-payments" : null} bgWhite />
        </div>
        {metadata.map((currency) => <section key={currency.code} aria-label={`${currency.code} commissions`}>
            <h3 className="mb-2 text-sm font-semibold">{currency.label === currency.code ? currency.code : `${currency.label} (${currency.code})`}</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <StatisticsCard label="Net commission" statistic={formatRecordedMoney(net[currency.code] ?? '0', currency.code, currency)} icon={HiOutlineCurrencyDollar} bgWhite />
                <StatisticsCard label="Gross commission" statistic={formatRecordedMoney(gross[currency.code] ?? '0', currency.code, currency)} icon={HiOutlineCurrencyDollar} />
                <StatisticsCard label="Payouts" statistic={formatRecordedMoney(payouts[currency.code] ?? '0', currency.code, currency)} icon={HiOutlineCurrencyDollar} />
            </div>
        </section>)}
    </div>;
}
